import React from 'react'
import PropTypes from 'prop-types'
import Collapsible from 'react-collapsible'
import Scroll from 'react-scroll'

class CollapsibleQuestions extends React.Component {
  componentDidMount() {
    this.props.section && this.scrollToElement()
  }

  scrollToElement() {
    const openedElement = document.getElementsByClassName('Collapsible is-opened')[0]

    setTimeout(() => {
      Scroll.animateScroll.scrollTo(openedElement.offsetTop)
    }, 100)
  }

  render() {
    const questions = {
      'get-credits': 'How can I get CGTrader Points?',
      'earn-rate': 'What is the Point Earn Rate?',
      'spend-credits': 'How can I spend CGTrader Points?',
      'use-credits': 'Can I use CGTrader Points for 3D Projects or assets with negotiated prices?',
    }

    return (
      <div className="questions-container">
        <Collapsible
          openedClassName="Collapsible is-opened"
          open
          trigger={questions['get-credits']}
          transitionTime={300}
        >
          <p>
            CGTrader Points are received after every purchase on CGTrader.
            The amount of CGTrader Points is determined by the value of your
            order and the Point Earn Rate. This percentage of the money spent
            is converted to CGTrader Points and added to your profile.
          </p>
        </Collapsible>

        <Collapsible
          openedClassName="Collapsible is-opened"
          open
          trigger={questions['earn-rate']}
          transitionTime={300}
        >
          <p>
            Point Earn Rate shows you the percentage of your order value which
            will be added to your account as CGTrader Points. It increases gradually
            when you place new orders and can reach a maximum of 30%. You can always
            check your current Point Earn rate in your Purchases page.
          </p>
        </Collapsible>

        <Collapsible
          openedClassName="Collapsible is-opened"
          open
          trigger={questions['spend-credits']}
          transitionTime={600}
        >
          <p>
            You can spend your CGTrader Points when purchasing models participating in the
            Loyalty Program (they are marked with a piggy bank icon and show a discount
            you will get with your CGTrader Points). Points can be used if the total value
            of your cart is equal to or greater than $15. They will be applied automatically
            and will cover up to 30% of the price.
          </p>
        </Collapsible>

        <Collapsible
          openedClassName="Collapsible is-opened"
          open
          trigger={questions['use-credits']}
          transitionTime={600}
        >
          <p>
            No, CGTrader Points can only be used only when purchasing participating models
            on the marketplace. You cannot cover part of the tailored 3D Project value or
            the final price negotiated via Offer Your Price feature with the points.
          </p>
        </Collapsible>
      </div>
    )
  }
}

CollapsibleQuestions.propTypes = {
  section: PropTypes.string,
}

CollapsibleQuestions.defaultPropTypes = {
  section: '',
}

export default CollapsibleQuestions
